import script from "./grid-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./grid-widget-ly.vue?vue&type=style&index=0&id=18c0aef4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c0aef4"]])

export default __exports__